import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, FormBuilder, Validators, UntypedFormArray } from '@angular/forms';
import {
  IBasketConfiguration,
  ITransactionMethod,
  ITransactionMethodConfiguration
} from '@shared/interfaces';
import { DEFAULT_TRANSACTION_NAMES, TRANSACTION_METHOD_LABELS } from 'src/app/util/Constant';
@Component({
  selector: 'basket-configuration',
  templateUrl: './basket-configuration.component.html',
  styleUrls: ['./basket-configuration.component.scss']
})
export class BasketConfigurationComponent implements OnInit {
  @Input() action: string;
  @Input() parentForm: UntypedFormGroup;
  @Input() basketConfiguration: IBasketConfiguration;
  @Input() authControlKey: string;

  constructor(private formBuilder: FormBuilder) {}
  EMAIL_FORMAT_TYPE = [
    { value: 'ATTACHMENT', name: 'Attachement' },
    { value: 'LIVE_LINK', name: 'Live Link' },
    { value: 'BODY', name: 'Body' }
  ];
  transactionMethods = ['In-Store', 'Web Order', 'Click and Collect', 'Ship to Store'];

  refundTypes = ['partial', 'full', 'unreferenced'];

  exchangeTypes = ['exchange', 'unreferencedExchange'];
  ngOnInit() {
    console.log('basketConfiguration', this.basketConfiguration);
    this.initForm();
  }
  initForm() {
    const generalConfiguration =
      this.basketConfiguration && this.basketConfiguration.generalConfiguration
        ? this.basketConfiguration.generalConfiguration
        : null;
    const receiptScreenConfiguration =
      this.basketConfiguration && this.basketConfiguration.receiptScreenConfiguration
        ? this.basketConfiguration.receiptScreenConfiguration
        : null;
    const productLineFields =
      this.basketConfiguration && this.basketConfiguration.productLineFieldConfiguration
        ? this.basketConfiguration.productLineFieldConfiguration
        : null;
    const transactionMethodConfiguration: ITransactionMethodConfiguration =
      this.basketConfiguration && this.basketConfiguration.transactionMethodConfiguration
        ? this.basketConfiguration.transactionMethodConfiguration
        : {};
    if (!transactionMethodConfiguration.transactionMethods) {
      transactionMethodConfiguration.transactionMethods = DEFAULT_TRANSACTION_NAMES.map((name) => ({
        transactionName: name
      }));
    }
    this.parentForm.addControl(
      this.authControlKey,
      this.formBuilder.group({
        restrictRefundsForSameTenders: [
          {
            value:
              generalConfiguration && generalConfiguration.restrictRefundsForSameTenders
                ? generalConfiguration.restrictRefundsForSameTenders.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        email: [
          {
            value:
              receiptScreenConfiguration && receiptScreenConfiguration.email
                ? receiptScreenConfiguration.email.status
                : true,
            disabled: this.action === 'view' ? true : false
          }
        ],
        emailTemplateFormat: [
          {
            value:
              receiptScreenConfiguration &&
              receiptScreenConfiguration.email &&
              receiptScreenConfiguration.email.status &&
              receiptScreenConfiguration.email.emailTemplateFormat
                ? receiptScreenConfiguration.email.emailTemplateFormat
                : this.EMAIL_FORMAT_TYPE[0].value,
            disabled: this.action === 'view' ? true : false
          }
        ],
        print: [
          {
            value:
              receiptScreenConfiguration && receiptScreenConfiguration.print
                ? receiptScreenConfiguration.print.status
                : true,
            disabled: this.action === 'view' ? true : false
          }
        ],
        reprintLimit: [
          {
            value:
              receiptScreenConfiguration && receiptScreenConfiguration.reprintLimit
                ? receiptScreenConfiguration.reprintLimit.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        numberOfReprintAllowed: [
          {
            value:
              receiptScreenConfiguration &&
              receiptScreenConfiguration.reprintLimit &&
              receiptScreenConfiguration.reprintLimit.numberOfReprintAllowed
                ? receiptScreenConfiguration.reprintLimit.numberOfReprintAllowed
                : 0,
            disabled: this.action === 'view' ? true : false
          },
          receiptScreenConfiguration &&
          receiptScreenConfiguration.reprintLimit &&
          receiptScreenConfiguration.reprintLimit.status
            ? [Validators.required]
            : []
        ],
        captureReprintReason: [
          {
            value:
              receiptScreenConfiguration && receiptScreenConfiguration.captureReprintReason
                ? receiptScreenConfiguration.captureReprintReason.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        giftReceipt: [
          {
            value:
              receiptScreenConfiguration && receiptScreenConfiguration.giftReceipt
                ? receiptScreenConfiguration.giftReceipt.status
                : true,
            disabled: this.action === 'view' ? true : false
          }
        ],
        skip: [
          {
            value:
              receiptScreenConfiguration && receiptScreenConfiguration.skip
                ? receiptScreenConfiguration.skip.status
                : true,
            disabled: this.action === 'view' ? true : false
          }
        ],
        both: [
          {
            value:
              receiptScreenConfiguration && receiptScreenConfiguration.both
                ? receiptScreenConfiguration.both.status
                : true,
            disabled: this.action === 'view' ? true : false
          }
        ],
        imageIcon: [
          {
            value:
              productLineFields && productLineFields.imageIcon
                ? productLineFields && productLineFields.imageIcon.status
                : true,
            disabled: this.action === 'view' ? true : false
          }
        ],
        shortDescription: [
          {
            value:
              productLineFields && productLineFields.shortDescription
                ? productLineFields && productLineFields.shortDescription.status
                : true,
            disabled: this.action === 'view' ? true : false
          }
        ],
        sku: [
          {
            value:
              productLineFields && productLineFields.sku
                ? productLineFields && productLineFields.sku.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        longDescription: [
          {
            value:
              productLineFields && productLineFields.longDescription
                ? productLineFields && productLineFields.longDescription.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        barcode: [
          {
            value:
              productLineFields && productLineFields.barcode
                ? productLineFields && productLineFields.barcode.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        style: [
          {
            value:
              productLineFields && productLineFields.style
                ? productLineFields && productLineFields.style.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        color: [
          {
            value:
              productLineFields && productLineFields.color
                ? productLineFields && productLineFields.color.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        size: [
          {
            value:
              productLineFields && productLineFields.size
                ? productLineFields && productLineFields.size.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        categoriesThread: [
          {
            value:
              productLineFields && productLineFields.categoriesThread
                ? productLineFields && productLineFields.categoriesThread.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        disablePromotion: [
          {
            value:
              transactionMethodConfiguration && transactionMethodConfiguration.disablePromotion
                ? transactionMethodConfiguration &&
                  transactionMethodConfiguration.disablePromotion.status
                : false,
            disabled: this.action === 'view' ? true : false
          }
        ],
        methods:
          transactionMethodConfiguration && transactionMethodConfiguration.transactionMethods
            ? this.formBuilder.array(
                transactionMethodConfiguration.transactionMethods.map(
                  (method: ITransactionMethod) => this.createMethodGroup(method)
                )
              )
            : this.formBuilder.array([])
      })
    );
  }
  getTransactionLabel(value: string): string {
    return TRANSACTION_METHOD_LABELS[value] || value;
  }
  createMethodGroup(method: ITransactionMethod): UntypedFormGroup {
    const group = this.formBuilder.group({
      transactionName: [method && method.transactionName ? method.transactionName : ''],

      sale: [method && method.sale !== undefined ? method.sale : true],
      partialRefund: [method && method.partialRefund !== undefined ? method.partialRefund : true],
      fullRefund: [method && method.fullRefund !== undefined ? method.fullRefund : true],
      unreferencedRefund: [
        method && method.unreferencedRefund !== undefined ? method.unreferencedRefund : true
      ],
      exchange: [method && method.exchange !== undefined ? method.exchange : true],
      unreferencedExchange: [
        method && method.unreferencedExchange !== undefined ? method.unreferencedExchange : true
      ],

      selectAll: [false]
    });

    this.setupSelectAllLogic(group);
    return group;
  }
  private setupSelectAllLogic(group: UntypedFormGroup): void {
    var fields = [
      'sale',
      'partialRefund',
      'fullRefund',
      'unreferencedRefund',
      'exchange',
      'unreferencedExchange'
    ];

    var selectAllCtrl = group.get('selectAll');
    fields.forEach(function(field) {
      var control = group.get(field);

      if (control) {
        control.valueChanges.subscribe(function() {
          var allChecked = true;
          for (var i = 0; i < fields.length; i++) {
            var childControl = group.get(fields[i]);
            if (!childControl || childControl.value !== true) {
              allChecked = false;
              break;
            }
          }

          if (selectAllCtrl) {
            selectAllCtrl.setValue(allChecked, { emitEvent: false });
          }
        });
      }
    });

    if (selectAllCtrl) {
      selectAllCtrl.valueChanges.subscribe(function(checked) {
        for (var i = 0; i < fields.length; i++) {
          var child = group.get(fields[i]);
          if (child) {
            child.setValue(checked, { emitEvent: false });
          }
        }
      });
    }

    setTimeout(function() {
      var allChecked = true;
      for (var i = 0; i < fields.length; i++) {
        var child = group.get(fields[i]);
        if (!child || child.value !== true) {
          allChecked = false;
          break;
        }
      }

      if (selectAllCtrl) {
        selectAllCtrl.setValue(allChecked, { emitEvent: false });
      }
    });
  }
  get methods(): UntypedFormArray {
    return this.parentForm.get(this.authControlKey).get('methods') as UntypedFormArray;
  }
  toggleSelectAll(index: number): void {
    const group = this.methods.at(index) as UntypedFormGroup;
    const selectAllControl = group.get('selectAll');
    const checked = selectAllControl ? selectAllControl.value : false;
    group.patchValue(
      {
        sale: checked,
        partialRefund: checked,
        fullRefund: checked,
        unreferencedRefund: checked,
        exchange: checked,
        unreferencedExchange: checked
      },
      { emitEvent: true }
    );
    if (selectAllControl) {
      selectAllControl.setValue(checked, { emitEvent: false });
    }
  }
  reprintLimitToggleChange(event): void {
    if (
      this.parentForm &&
      this.parentForm.get(this.authControlKey) &&
      this.parentForm.get(this.authControlKey).get('numberOfReprintAllowed')
    ) {
      if (event && event.checked) {
        this.parentForm
          .get(this.authControlKey)
          .get('numberOfReprintAllowed')
          .setValidators(Validators.required);
      } else {
        this.parentForm
          .get(this.authControlKey)
          .get('numberOfReprintAllowed')
          .clearValidators();
      }
    }
  }
}
